module.exports = __webpack_public_path__ + "img/outline_lacak.1037f2d4.svg";